var map = {
	"./African_catfish.jpg": "5c74",
	"./African_catfish.png": "01d2",
	"./Amur.jpg": "2023",
	"./Background.jpg": "62c0",
	"./Business.jpg": "160d",
	"./Business.png": "f860",
	"./Cage.jpg": "ea52",
	"./Carp.jpg": "a0bb",
	"./Closed_water_supply_installation.jpg": "77d4",
	"./Economy.jpg": "f02e",
	"./Economy.png": "e04b",
	"./Lakes_commercial_fish_farming.jpg": "c033",
	"./Peled.jpg": "ebce",
	"./Peled.png": "edd8",
	"./Pond_fish_farming.jpg": "9696",
	"./Silver_carp.jpg": "1365",
	"./Sturgeon.jpg": "c538",
	"./Trout.jpg": "94e9",
	"./c7a888ef1b4daeca68627d9e8e9650ad.jpg": "3c6a",
	"./c7a888ef1b4daeca68627d9e8e9650ad.png": "cca4",
	"./kazakhstanMap": "78de",
	"./kazakhstanMap.js": "78de",
	"./kz/1.ogg": "0072",
	"./kz/21.ogg": "59f5",
	"./kz/23.ogg": "6bba",
	"./kz/25.ogg": "7aa5b",
	"./kz/27.ogg": "b2e0",
	"./kz/3.ogg": "c6f4",
	"./kz/30.ogg": "6b2a",
	"./kz/31.ogg": "b876",
	"./kz/32.ogg": "ae57",
	"./kz/33.ogg": "9b5b",
	"./kz/34.ogg": "8f0d",
	"./kz/35.ogg": "639c",
	"./kz/36.ogg": "080b",
	"./kz/37.ogg": "3728",
	"./kz/38.ogg": "6adf",
	"./kz/4.ogg": "785d",
	"./kz/5.ogg": "8e32",
	"./kz/6.ogg": "548f",
	"./kz/8.ogg": "5739",
	"./kz/KZ-AKM.ogg": "c8a9",
	"./kz/KZ-AKT.ogg": "36a3",
	"./kz/KZ-ALM.ogg": "61fd",
	"./kz/KZ-AS.ogg": "3da0",
	"./kz/KZ-ATY.ogg": "877d",
	"./kz/KZ-KAR.ogg": "942e",
	"./kz/KZ-KUS.ogg": "225d",
	"./kz/KZ-KZY.ogg": "c534",
	"./kz/KZ-MAN.ogg": "2750",
	"./kz/KZ-PAV.ogg": "1b2d",
	"./kz/KZ-SEV.ogg": "56db",
	"./kz/KZ-VOS.ogg": "d3f3",
	"./kz/KZ-YUZ.ogg": "66b3",
	"./kz/KZ-ZAP.ogg": "ffe7",
	"./kz/KZ-ZHA.ogg": "397e",
	"./logo.png": "cf05",
	"./logo_agrar.webp": "fd84",
	"./md_5b321ca7cfbef.png": "8199",
	"./ru/1.ogg": "cfb5",
	"./ru/21.ogg": "1087",
	"./ru/23.ogg": "a39a",
	"./ru/25.ogg": "a737",
	"./ru/27.ogg": "233e",
	"./ru/3.ogg": "0bd7",
	"./ru/30.ogg": "57ea",
	"./ru/31.ogg": "111e",
	"./ru/32.ogg": "a6fd",
	"./ru/33.ogg": "d955",
	"./ru/34.ogg": "c6c4",
	"./ru/35.ogg": "9480",
	"./ru/36.ogg": "64c9",
	"./ru/37.ogg": "68bd",
	"./ru/38.ogg": "9f06",
	"./ru/4.ogg": "e108",
	"./ru/5.ogg": "44b2",
	"./ru/6.ogg": "f613",
	"./ru/8.ogg": "f1ce",
	"./ru/KZ-AKM.ogg": "fc97",
	"./ru/KZ-AKT.ogg": "51356",
	"./ru/KZ-ALM.ogg": "4658",
	"./ru/KZ-AS.ogg": "559d",
	"./ru/KZ-ATY.ogg": "bd27",
	"./ru/KZ-KAR.ogg": "d05c",
	"./ru/KZ-KUS.ogg": "cca2",
	"./ru/KZ-KZY.ogg": "c463",
	"./ru/KZ-MAN.ogg": "9fac",
	"./ru/KZ-PAV.ogg": "fa47",
	"./ru/KZ-SEV.ogg": "b5ed",
	"./ru/KZ-VOS.ogg": "9c6e",
	"./ru/KZ-YUZ.ogg": "93d9",
	"./ru/KZ-ZAP.ogg": "2292",
	"./ru/KZ-ZHA.ogg": "e019"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";